<div class="header-container">
  <div class="filters-container">
    <!-- Search Field -->
    <mat-form-field appearance="outline" class="search-field">
      <input matInput [(ngModel)]="searchKeyword" placeholder="Search items" (input)="onSearch()">
      <mat-progress-spinner *ngIf="searchingKeywords" matSuffix diameter="20" mode="indeterminate"
        class="search-spinner">
      </mat-progress-spinner>
      <button mat-icon-button matSuffix *ngIf="searchKeyword" (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>

    <!-- Select Company Dropdown -->
    <mat-form-field class="company-dropdown">
      <mat-label>Select companies</mat-label>
      <mat-select [(ngModel)]="selectedCompanies" name="companies" (selectionChange)="onSelectionChange($event)"
        multiple>
        <mat-option *ngFor="let company of companies" [value]="company">
          {{ company }}
        </mat-option>
      </mat-select>
      <button mat-icon-button matSuffix (click)="resetSelection()" *ngIf="selectedCompanies?.length">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <!-- Download Excel Button -->
  <div class="download-button-container">
    @if (!downloadingExcel) {
    <button mat-button (click)="exportToExcel()">
      <mat-icon>download</mat-icon> XLSX
    </button>
    } @else {
    <mat-spinner class="download-spinner" diameter="20"></mat-spinner>
    }
  </div>
</div>

<div class="table-container">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort [matSortDisableClear]="true"
    (matSortChange)="announceSortChange($event)">

    <!-- Own Account Column -->
    <ng-container matColumnDef="sourceAccountId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by source account ID">
        Source Account ID
      </th>
      <td mat-cell *matCellDef="let element"> {{element.sourceAccountId}} </td>
    </ng-container>

    <!-- Department ID Column -->
    <ng-container matColumnDef="sourceDepartmentCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by source department code">
        Source department code
      </th>
      <td mat-cell *matCellDef="let element"> {{element.sourceDepartmentCode}} </td>
    </ng-container>

    <!-- Group Account Column -->
    <ng-container matColumnDef="groupAccountId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by group account ID">
      Group Account ID
      </th>
      <td mat-cell *matCellDef="let element">
      @if (!element.isEditing) {
      <ng-container>{{element.groupAccountId}}</ng-container>
      } @else {
      <mat-form-field>
        <mat-select [(ngModel)]="element.groupAccountId" name="groupAccountId"
        (selectionChange)="getGroupAccountNameAndType(element)">
        <mat-option>
          <ngx-mat-select-search [formControl]="groupAccountFilterCtrl" placeholderLabel="Search group account ID"
          noEntriesFoundLabel="Not found">
          </ngx-mat-select-search>
        </mat-option>

        <mat-option *ngFor="let groupAccountId of filteredGroupAccounts" [value]="groupAccountId.id">
          {{ groupAccountId.displayName }}
        </mat-option>
        </mat-select>
        <button mat-icon-button matSuffix (click)="toggleSortOrder()" class="sort-button" tabindex="-1">
        <mat-icon>{{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
        </button>
      </mat-form-field>
      }
      </td>
    </ng-container>

    <!-- Company Column -->
    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by company">
        Company
      </th>
      <td mat-cell *matCellDef="let element"> {{element.company}} </td>
    </ng-container>

    <!-- Source Account Name Column -->
    <ng-container matColumnDef="sourceAccountName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by source account name">
        Source Account Name
      </th>
      <td mat-cell *matCellDef="let element"> {{element.sourceAccountName}} </td>
    </ng-container>

    <!-- Group Account Name Column -->
    <ng-container matColumnDef="groupAccountName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Group Account Name </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.isLoadingGroupAccountName; else displayName">
          <mat-spinner diameter="20"></mat-spinner>
        </ng-container>
        <ng-template #displayName>
          {{ element.groupAccountName }}
        </ng-template>
      </td>
    </ng-container>

    <!-- Account Type Column -->
    <ng-container matColumnDef="accountType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Account Type </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.isLoadingGroupType; else displayType">
          <mat-spinner diameter="20"></mat-spinner>
        </ng-container>
        <ng-template #displayType>
          {{ element.accountType }}
        </ng-template>
      </td>
    </ng-container>
    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by status">
        Status
      </th>
      <td mat-cell *matCellDef="let element"> {{status[element.status].name}} </td>
    </ng-container>

    <!-- Created Column -->
    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by created datetime">
        Created
      </th>
      <td mat-cell *matCellDef="let element"> {{element.created | date:'dd.MM.yyyy HH:mm' }} </td>
    </ng-container>

    <!-- Modified Column -->
    <ng-container matColumnDef="modified">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by modified datetime">
        Modified
      </th>
      <td mat-cell *matCellDef="let element">
        @if (element.modifiedString) {
        {{element.modifiedString | date:'dd.MM.yyyy HH:mm' : 'UTC' }}
        } @else {
        {{element.modified | date:'dd.MM.yyyy HH:mm' }}
        }
      </td>
    </ng-container>

    <!-- Modifier Column -->
    <ng-container matColumnDef="modifier">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by modifier">
        Modifier
      </th>
      <td mat-cell *matCellDef="let element"> {{element.modifier}} </td>
    </ng-container>

    <!-- Locked Column -->
    <ng-container matColumnDef="locked">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by locked">
        Locked
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="!element.isEditing; else editTemplate">
          <mat-icon *ngIf="element.locked; else unlockedIcon">lock</mat-icon>
          <ng-template #unlockedIcon>
            <mat-icon>lock_open</mat-icon>
          </ng-template>
        </ng-container>
        <ng-template #editTemplate>
          <ng-container *ngIf="isCurrentUserAdmin; else lockedDisplay">
            <mat-slide-toggle [(ngModel)]="element.locked">
              <ng-container *ngIf="element.locked; else unlockedIcon">
                <mat-icon>lock</mat-icon>
              </ng-container>
              <ng-template #unlockedIcon>
                <mat-icon>lock_open</mat-icon>
              </ng-template>
            </mat-slide-toggle>
          </ng-container>
          <ng-template #lockedDisplay>
            <ng-container *ngIf="element.locked; else unlockedText">
              <mat-icon>lock</mat-icon>
            </ng-container>
            <ng-template #unlockedText>
              <mat-icon>lock_open</mat-icon>
            </ng-template>
          </ng-template>
        </ng-template>
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element">
        @if (element.isEditing) {
        <ng-container>
          <div class="button-container">
            <button mat-icon-button matTooltip="Save" class="save-button" (click)="saveElement(element)"
              [disabled]="!element.groupAccountId || element.groupAccountId == -1 || element.isSaving || element.isLoadingGroupAccountName || element.isLoadingGroupType">
              @if (!element.isSaving) {
              <mat-icon class="material-symbols-outlined">save</mat-icon>
              } @else {
              <ng-container>
                <mat-spinner diameter="20"></mat-spinner>
              </ng-container>
              }
            </button>
            <button mat-icon-button class="discard-button" matTooltip="Cancel" (click)="discardChanges(element)"
              [disabled]="element.isSaving">
              <mat-icon class="material-symbols-outlined">cancel</mat-icon>
            </button>
          </div>
        </ng-container>
        }

        <ng-container>
          <div class="button-container">
            @if (!element.isEditing && (isCurrentUserAdmin || !element.locked)) {
            <span (click)="editElement(element)" matTooltip="Edit" class="material-symbols-outlined clickable">
              edit
            </span>
            }
            @if (!element.isEditing && element.status === Status.AwaitingApproval && isCurrentUserAdmin) {
            <span *ngIf="!element.approving" (click)="approveElement(element)" matTooltip="Approve" class="material-symbols-outlined clickable">
              check_circle
            </span>
            <mat-spinner *ngIf="element.approving" class="download-spinner" diameter="20"></mat-spinner>
            }
          </div>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{
        'highlight-row-notMapped': row.status === Status.NotMapped,
        'highlight-row-mapped': row.status === Status.OK,
        'highlight-row-awaitingApproval': row.status === Status.AwaitingApproval
      }">
    </tr>
  </table>
  <!-- No data message -->
  <div *ngIf="!isLoading && dataSource.data.length === 0" class="no-data-message">
    No data available
  </div>
</div>
<div class="loading-overlay" *ngIf="isLoading">
  <mat-spinner diameter="50"></mat-spinner>
</div>

@if (!isLoading && page.length > 10) {
<mat-paginator [length]="page.length" [pageSize]="page.pageSize" [pageIndex]="page.pageIndex"
  [pageSizeOptions]="[10, 50, 100]" (page)="pageChanged($event)" aria-label="Select page" [showFirstLastButtons]="true">
</mat-paginator>
}
